import React, { useCallback, useEffect, useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import { Modal } from 'react-bootstrap'

const ModalPreviewTte = ({ showViewTte, handleCloseViewTte, dataDisposisi, dataPpmKapal }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [dataTte, setDataTte] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal.nomorAjuKapal || (dataDisposisi.idDisposisi !== 8 && dataDisposisi.idDisposisi !== 9)) {
            return
        }

        try {
            let modul
            let idSiapmutu
            if (dataDisposisi.idDisposisi === 8) {
                modul = 'Sertifikat CPIB Kapal'
                const resSert = await kapalService.listKapalSertifikat(dataPpmKapal.nomorAjuKapal, null, dataPpmKapal.namaKapal)
                if (resSert.data.data.length > 0) {
                    idSiapmutu = resSert.data.data[0].nomorSertifikat
                }
            } else {
                modul = 'SPT Primer'
                idSiapmutu = dataPpmKapal.nomorAjuKapal
            }
            const resTte = await kapalService.viewFileTteByIdAndModul(idSiapmutu, modul)
            setDataTte(resTte.data)
        } catch (error) {
            console.log(error)
        }
    }, [dataDisposisi, dataPpmKapal, kapalService])

    useEffect(() => {
            let isMounted = true;
            if (!dataPpmKapal || !dataDisposisi) return;
    
            const loadData = async () => {
                try {
                    await fetchAllData();
                } catch (e) {
                    if (isMounted) console.error(e);
                }
            };
    
            loadData();
    
            return () => { isMounted = false; };
        }, [dataPpmKapal, dataDisposisi, fetchAllData]);

    return (
        <>
            <Modal show={showViewTte} onHide={handleCloseViewTte} size='xl'>
                {
                    dataTte &&
                    <iframe
                        src={dataTte.linkTerima}
                        title='Preview PDF'
                        width="100%"
                        height="800px"
                    ></iframe>
                }
            </Modal>
        </>
    )
}

export default ModalPreviewTte